import React, { useState, useEffect } from "react";
import { useParams } from "react-router";
import { Space, Row, Spinner } from "@masterteam/mt-design-react";

import Tabs from "./Tabs";
import Header from "./Header";
import InitCard from "./InitCard";

import api from "../../providers/api";
import { addToast } from "../../helpers";

import "./style.scss";

const InitiativeDetails = () => {
  const [loading, setLoading] = useState(true);
  const [initiative, setInitiative] = useState([]);
  const params = useParams();

  const getInitiatives = async () => {
    setLoading(true);
    try {
      const res = await api.initiatives.getById(params?.id);
      setInitiative(res.Data);
    } catch (err) {
      addToast.error(err.message, {
        toastId: "get-users-error",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getInitiatives();
  }, []);

  return (
    <Space direction="vertical" className="initiative-details-container">
      <Header />

      {loading ? (
        <Row justify="center" style={{ marginTop: "24px" }}>
          <Spinner size="large" />
        </Row>
      ) : (
        <Space className="initiative-details-container__details" gap={20}>
          <InitCard data={initiative} />
          <Tabs data={initiative} loader={loading} />
        </Space>
      )}
    </Space>
  );
};

export default InitiativeDetails;
